<template>
  <i18n-t
    keypath="components.terms_and_conditions.message"
    tag="p"
    class="text-sm font-medium text-gray-600"
  >
    <template v-slot:label>
      <span v-text="label" class="text-lowercase" />
    </template>
    <template v-slot:terms>
      <a
        href="https://www.fixform.com/terms-of-use"
        target="_blank"
        v-text="t('components.terms_and_conditions.terms_label')"
        class="underline hover:text-gray-900"
      />
    </template>
    <template v-slot:privacy>
      <a
        href="https://www.fixform.com/privacy-policy"
        target="_blank"
        v-text="t('components.terms_and_conditions.privacy_label')"
        class="underline hover:text-gray-900"
      />
    </template>
  </i18n-t>
</template>

<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps({
  label: {
    type: String,
    required: true,
  },
});
</script>
